// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2lqX7","subheader":"ReorderModal_subheader__1vep5","listWrap":"ReorderModal_listWrap__38uEf"};